import type { Role } from '../types/auth';

/**
 * Role sets mirroring the backend authorization policies
 * (ExamFolio.Infrastructure.Auth.AuthorizationPolicies). The API is the security boundary —
 * these only decide which routes and nav items the client offers, so a user never lands on
 * a page whose every request would 403. Keep them in lockstep with the backend.
 */
export const Policies = {
  administrator: ['Administrator'],
  administratorOrQuestionAuthor: ['Administrator', 'QuestionAuthor'],
  questionWorkflowParticipant: [
    'Administrator',
    'QuestionAuthor',
    'Screener',
    'Validator',
    'Translator',
    'CommitteeMember',
  ],
  // 29.14: CommitteeMember (legacy "Writing committee member") is a question writer, not exam
  // staff — it reaches the question pool through questionWorkflowParticipant and nothing else.
  examStaff: ['Administrator', 'LocationSupervisor'],
  candidate: ['Candidate'],
  /** Client-only: every role that may enter the admin shell at all. */
  staff: [
    'Administrator',
    'QuestionAuthor',
    'Screener',
    'Validator',
    'Translator',
    'CommitteeMember',
    'LocationSupervisor',
  ],
} as const satisfies Record<string, readonly Role[]>;

export function hasAnyRole(userRoles: readonly string[], required: readonly Role[]): boolean {
  return required.some((role) => userRoles.includes(role));
}
